import { TTS_EVENTS } from '../constants/constants';

/**
 * Notify the TT-1166 "thinking" bubble that a TTS request reached a terminal state (audio
 * started/ended, error, abort, or skip), keyed by the exact `_speechRequestId`.
 *
 * Lives in its own module (rather than on LexaSpeech) so both dispatch sites — LexaSpeech's
 * terminal callbacks and Speech.abortSpeech's barge-in path — share one implementation and
 * one guard, without the LexaSpeech <-> Speech circular import.
 *
 * @param {number} requestId - The utterance's `_speechRequestId`.
 */
export function dispatchTtsRequestEnded(requestId) {
  // Require a numeric id (ids can be 0): guards against a caller passing a non-id first
  // argument (e.g. a speechObj) and dispatching a garbage requestId.
  if (typeof window === 'undefined' || typeof requestId !== 'number') {
    return;
  }
  window.dispatchEvent(new CustomEvent(TTS_EVENTS.REQUEST_ENDED, {
    detail: { requestId },
  }));
}
